<div class="modal-box h-overflow p-0 vh-100">
  <ngx-spinner type="ball-spin" size="medium"></ngx-spinner>
  <app-header></app-header>
  <router-outlet></router-outlet>
</div>